module.exports = __webpack_public_path__ + "img/pantalla-9-11.b0a255cd.png";